// 1. Framework / library imports
import { memo } from "react";

// 2. Helpers
import { useTranslate } from "helpers";

// 3. UI Components
import { TableSearch } from "ui/components/Table/TableSearch";

// 4. Local Components
import VehicleExpenseRowChild from "./components/VehicleExpenseRowChild";

// 5. Project-specific constants & types
import { initialDataWithPagination } from "services/api/consts";
import {
  FLEET_VEHICLE_EXPENSE_SEARCH_COLUMNS,
  FLEET_VEHICLE_EXPENSE_UPLOADS_SEARCH_COLUMNS,
} from "./consts";
import { VehicleExpenseSearchResultsProps } from "./types";


const VehicleExpenseSearchResults: React.FC<VehicleExpenseSearchResultsProps> = (
  props
) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
    onDeleteClick,
  } = props;

  const { t } = useTranslate();

  return (
    <>
      <TableSearch
        columns={FLEET_VEHICLE_EXPENSE_SEARCH_COLUMNS(t, onDeleteClick)}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
        columnsChild={FLEET_VEHICLE_EXPENSE_UPLOADS_SEARCH_COLUMNS(t)}
        CustomTableRowChild={(childProps) => (
          <VehicleExpenseRowChild
            {...childProps}
            onFetchSearchResult={() =>
              onPaginationChange?.(searchResults.pagination)
            }
          />
        )}
      />
    </>
  );
};
export default memo(VehicleExpenseSearchResults);
